import type { ChatGame } from './chat-games.js';

/** Terminal games remain in the timeline; only a live invitation/session may claim the chat surface. */
export function shouldAutoOpenCurrentGame(
  game: Pick<ChatGame, 'id' | 'status'> | null | undefined,
  openedGameId?: string,
  dismissedGameId?: string,
): boolean {
  return Boolean(
    game &&
    ['INVITED', 'ACTIVE'].includes(game.status) &&
    game.id !== openedGameId &&
    game.id !== dismissedGameId,
  );
}
